import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const languageFlags = {
  pl: "🇵🇱",
  en: "🇬🇧",
  ru: "🇷🇺",
  uk: "🇺🇦",
};

const languageNames = {
  pl: "Polski",
  en: "English",
  ru: "Русский",
  uk: "Українська",
};

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="w-[100px] justify-start gap-2">
          <span>{languageFlags[language]}</span>
          <span className="uppercase">{language}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {Object.entries(languageFlags).map(([code, flag]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLanguage(code as "pl" | "en" | "ru" | "uk")}
            className="gap-2 cursor-pointer"
          >
            <span>{flag}</span>
            <span className="uppercase">{code}</span>
            <span className="ml-2 text-muted-foreground">
              {languageNames[code]}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
